import React from 'react';
import {useTranslation} from "react-i18next";
import {Dropdown} from "react-bootstrap";
import US from 'country-flag-icons/react/3x2/US';
import {NL} from "country-flag-icons/react/3x2";
import css from '../css/LanguageSelector.module.css'

const LanguageSelector = () => {
    const { t, i18n } = useTranslation();

    const languages = [
        {
            name: 'English',
            icon: <US style={{ width: '20px', marginRight: '4px' }} />,
            code: 'en'
        },
        {
            name: 'Nederlands',
            icon: <NL style={{ width: '20px', marginRight: '4px' }} />,
            code: 'nl'
        }
    ];

    const changeLanguage = async (languageCode) => {
        await i18n.changeLanguage(languageCode);
    };

    return (
        <Dropdown className={'w-100'}>
            <Dropdown.Toggle variant="outline-light" id="dropdown-language" className={'w-100'}>
                {languages.find(lang => lang.code === i18n.language)?.icon}
                <span className={'text-uppercase'}>{languages.find(lang => lang.code === i18n.language)?.code}</span>
            </Dropdown.Toggle>

            <Dropdown.Menu className={'px-2'}>
                {languages.map(language => {
                    const active = i18n.language === language.code;
                    const activeClasses = active ? `${css.activeItem} border-primary` : '';

                    return (
                        <Dropdown.Item
                            className={`rounded my-1 text-black border border-1 ${activeClasses} ${css.item}`}
                            variant={'light'}
                            key={language.code}
                            onClick={() => changeLanguage(language.code)}
                            active={active}>

                            {language.icon} {language.name}
                        </Dropdown.Item>
                )})}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default LanguageSelector;
